import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  autocomplete: "off",
  class: "w-full relative mb-2"
}
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "flex items-center relative w-1/3" }
const _hoisted_4 = { class: "w-2/3 flex items-center" }
const _hoisted_5 = { class: "absolute z-10 bg-white shadow min-w-80" }
const _hoisted_6 = { class: "cursor-pointer border-b px-2 py-1 hover:bg-next-light-gray" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDelete = _resolveComponent("ConfirmDelete")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("input", {
      autocomplete: "false",
      name: "hidden",
      type: "text",
      style: {"display":"none"}
    }, null, -1)),
    _createVNode(_component_Field, { field_name: "Cerca posizione" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.address) = $event)),
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearchLocation && _ctx.onSearchLocation(...args))),
              type: "text",
              placeholder: "Cerca",
              class: "p-7px bg-next-gray-md-dark hover:bg-white w-full pr-1.5"
            }, null, 544), [
              [_vModelText, _ctx.address]
            ]),
            _withDirectives(_createElementVNode("i", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args))),
              class: "cursor-pointer absolute icon-croce rotate-45 right-1"
            }, null, 512), [
              [_vShow, _ctx.address || _ctx.risultati.length]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "actual", { actual: _ctx.actual }),
            _withDirectives(_createVNode(_component_ConfirmDelete, {
              position: "left",
              onCancella: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('remove'))),
              class: "pl-3"
            }, null, 512), [
              [_vShow, _ctx.placeId]
            ])
          ])
        ])
      ]),
      _: 3
    }),
    _createElementVNode("ul", _hoisted_5, [
      _withDirectives(_createElementVNode("li", _hoisted_6, "Nessun risultato trovato ", 512), [
        [_vShow, !_ctx.risultati.length && _ctx.address.length]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.risultati, (risultato) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "cursor-pointer border-b px-2 py-1 hover:bg-next-light-gray",
          onClick: ($event: any) => (_ctx.chose(risultato)),
          key: risultato.place_id
        }, _toDisplayString(risultato.formatted_address), 9, _hoisted_7))
      }), 128))
    ])
  ]))
}